import React, { useRef } from 'react';

import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import Image from 'next/image';

import Button from '@/components/Button';

import Card from '@/components/Card';

import Svg from '@/components/Svg';

import Backdrop from './Backdrop';
import styles from './Modal.module.scss';
import ScrollTrap from './ScrollTrap';

type ControllableModalProps = {
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
  modalTopImageUrl?: string;
  modalName?: string;
  isScrollVisible?: boolean;
  isShow: boolean;
  onClose: () => void;
};

const ControllableModal = ({
  className,
  contentClassName,
  children,
  modalTopImageUrl,
  modalName,
  isScrollVisible,
  isShow,
  onClose,
}: ControllableModalProps) => {
  const backdropRef = useRef<HTMLButtonElement>(null);

  const modalContent = classNames({
    [styles.modal__modalcontent]: !isScrollVisible,
    [styles.modal__modalcontent_visible_scroll]: isScrollVisible,
    [contentClassName as string]: !!contentClassName,
  });

  return (
    <ScrollTrap isActive={isShow}>
      <FocusTrap
        active={isShow}
        focusTrapOptions={{ initialFocus: false, fallbackFocus: backdropRef.current || undefined }}
      >
        <div className={classNames(styles.modal, className, { [styles.isClosed]: !isShow })}>
          {modalTopImageUrl && (
            <div className={styles['card-icons']}>
              <Image src={modalTopImageUrl} height={80} width={80} alt="modaltopImage" />
            </div>
          )}
          <div className={modalContent}>
            <Card className={styles.cardpadding}>
              <div className={styles.cross}>
                <Button
                  className={modalName === 'arrow-close-right' ? styles['close-btn'] : styles.btn}
                  onClick={onClose}
                >
                  <Svg glyph="close" width={20} height={20} ariaLabel="close" iconId="close" fill="#6e6e6e" />
                </Button>
              </div>
              <div>{children}</div>
            </Card>
          </div>
          <Backdrop ref={backdropRef} backDropClass={styles.modal__backdrop} onClose={onClose} />
        </div>
      </FocusTrap>
    </ScrollTrap>
  );
};

export default ControllableModal;
